import { api } from './index';
import { API_ENDPOINTS } from '@/constants';
import type {
  CallQualityMetricsDTO,
  AgentQualityMetricsDTO,
  GetCallQualityMetricsParams,
  GetAgentQualityMetricsParams,
} from '@/types/qualityMetrics';

export const qualityMetricsApi = api.injectEndpoints({
  endpoints: builder => ({
    getCallQualityMetrics: builder.query<
      CallQualityMetricsDTO,
      GetCallQualityMetricsParams
    >({
      query: ({ contactId }) => {
        const url = `${API_ENDPOINTS.QUALITY_METRICS.CALL}/${contactId}`;
        return url;
      },
      providesTags: ['QualityMetrics'],
    }),

    getAgentQualityMetrics: builder.query<
      AgentQualityMetricsDTO,
      GetAgentQualityMetricsParams
    >({
      query: ({ agentId, startTime, endTime }) => {
        const url = `${API_ENDPOINTS.QUALITY_METRICS.AGENT}/${agentId}`;
        const params = new URLSearchParams();
        if (startTime) params.append('startTime', startTime);
        if (endTime) params.append('endTime', endTime);
        const queryString = params.toString();
        return queryString ? `${url}?${queryString}` : url;
      },
      providesTags: ['QualityMetrics'],
    }),
  }),
});

export const { useGetCallQualityMetricsQuery, useGetAgentQualityMetricsQuery } =
  qualityMetricsApi;
